module.exports = __webpack_public_path__ + "img/icon8.5ab367f1.png";